export const formatVND = (n) =>
  new Intl.NumberFormat('vi-VN').format(Math.round(Number(n) || 0)) + '₫';

export const effectivePrice = (item) => {
  const sale = Number(item?.sale_price);
  const price = Number(item?.price) || 0;
  return sale && sale < price ? sale : price;
};

// Bilingual field picker: falls back to Vietnamese when EN is empty
export const pickLang = (row, field, lang) =>
  lang === 'en' && row?.[`${field}_en`] ? row[`${field}_en`] : row?.[field] ?? '';

const CATEGORY_EMOJI = {
  'Yến sào': '🪺',
  'Trầm hương': '🪵',
  'Đặc sản': '🦐',
  'Lưu niệm': '🐚',
  'Mỹ phẩm thiên nhiên': '🧴',
  'Thời trang': '👒',
};

export const emojiFor = (category) => CATEGORY_EMOJI[category] || '🎁';

export const shortId = (uuid) => (uuid || '').slice(0, 8).toUpperCase();
